import { render, staticRenderFns } from "./apiaryDetails.vue?vue&type=template&id=593c55a6&"
import script from "./apiaryDetails.vue?vue&type=script&lang=js&"
export * from "./apiaryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports